export const MAX_FIELD_OPTIONS_PER_FIELD = 100;
